/**
 * @description m => km
 * @param value string
 */
function convert(value: string): string {
	if (!value) {
		console.log('value 不能为空')
		return '0';
	}
	let result = parseInt(value);
	return result > 1000 ? ((result / 1000).toFixed(2) + ' k') : result + ' ';
}

/**
 * @description digital toFixed
 * @param value string
 * @param decimals string
 */
function digitalFormat(value: string, decimals: number): string {
	if (!value) return '0';
	const result = parseInt(value);
	if (isNaN(result)) {
		console.log('传入的值解析错误')
		return '0';
	}
	return result.toFixed(decimals);
}


/**
 * @description digital prefix zore
 * @param number string
 */
const zore = (number: number): string => {
	return number < 10 ? ('0' + number) : number + '';
};

/**
 * @description ms => {minute, second}
 * @param remain string
 * @param remain string
 */
function msToTime(remain: number): object {
	const
		minute = parseInt(`${remain / 60000}`),
		second = parseInt(`${remain % 60000 / 1000}`);

	return {
		minute: isNaN(minute) ? 0 : minute,
		second: isNaN(second) ? 0 : second
	}
}

/**
 * @description 适配
 * @param number string
 */
const adaptorPC = (): any => {
	let userAgentInfo = navigator.userAgent;
	// console.log(userAgentInfo);
	let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
	let flag = true;
	for (let v = 0; v < Agents.length; v++) {
		if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
	}
	return flag;
}

/**
 * @description android or ios
 * @param number string
 */
const detectOS = (): string => {
	const sUserAgent = navigator.userAgent;

	// 先判断手机系统
	const bIsAndroid = sUserAgent.toLowerCase().match(/android/i) && sUserAgent.toLowerCase().match(/android/i)[0] === 'android';
	if (bIsAndroid) return 'android';

	const isiOS = !!sUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
	if (isiOS) return 'ios';
}

export {
	convert,
	digitalFormat,
	zore,
	msToTime,
	adaptorPC,
	detectOS
}



// WEBPACK FOOTER //
// ./src/common/utils.tsx